import React from "react";
import { graphql } from "gatsby";
import { Hero as HeroComponent } from "@zempler/theme/src/components/hero/Hero";
import { ButtonBar } from "@zempler/theme/src/components/buttonbar/ButtonBar";
import { ButtonComponentRenderer } from "../../ButtonComponentRenderer";

export const Hero = ({ data, ...rest }) => {
  function formatString(inputString: "belowText" | "bottomRight") {
    return inputString
      ?.toLowerCase()
      .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      })
      .replace(/\s+/g, "");
  }

  const buttonPlacement = formatString(data.buttonPlacement);

  return (
    <>
      <HeroComponent
        {...data}
        image={data?.useSmallImage ? data?.smallImage?.image?.localFile :  data?.image?.image?.localFile}
        buttonPlacement={buttonPlacement}
        buttons={
          data?.buttons?.buttons && data?.buttons?.buttons?.length > 0 ? (
            <ButtonBar {...data}>
              {data?.buttons?.buttons?.map((button, index) => (
                <ButtonComponentRenderer
                  components={[button?.component]}
                  dataLayerClickContext="Hero"
                  key={index}
                />
              ))}
            </ButtonBar>
          ) : null
        }
      />
    </>
  );
};

export const HeroQuery = graphql`
  fragment Hero on UMBRACO_HeroComponentType {
    superTitle
    heading
    subHeading
    ticks
    backgroundColor
    buttonPlacement
    buttons {
      buttons {
        component {
          ...ButtonComponents
        }
      }
    }
    image {
      image {
        ...HeroImage
      }
    }
    smallImage: image {
      image {
        ...HeroImageSmall
      }
    }
    useSmallImage
    smallText
    bottomLogos: bottomLogoAndLinks {
      logo {
        image {
          altText
          ...HeroLogo
        }
      }
      logoLink {
        ...Link
      }
    }
    topLogos: topLogosAndLinks {
      logo {
        image {
          altText
          ...HeroLogo
        }
      }
      logoLink {
        ...Link
      }
    }
  }
`;
